import axios from 'axios';
import { API_BASE_URL } from '../config';
import { getAppPathname, getAppSearch, navigateTo } from './platform';
import { invalidateBookingsCache } from './cache';

// Helper function to get businessid from URL
const getBusinessId = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('businessid');
};

// Create axios instance
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add JWT token and businessid to all requests
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Add businessid to query params if available
    const businessId = getBusinessId();
    if (businessId) {
      config.params = config.params || {};
      config.params.businessid = businessId;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token expiration
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error.response?.status;
    if (status === 401 || status === 422) {
      const hadToken = !!localStorage.getItem('token');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      invalidateBookingsCache();
      // Only force redirect if user had a token (session expired or invalid)
      if (hadToken) {
        sessionStorage.setItem('loginReturnTo', JSON.stringify({
          pathname: getAppPathname(),
          search: getAppSearch(),
        }));
        const params = new URLSearchParams(getAppSearch());
        const businessId = params.get('businessid');
        const loginParams = new URLSearchParams();
        if (businessId) loginParams.set('businessid', businessId);
        const view = params.get('view');
        if (view) loginParams.set('view', view);
        const loginSearch = loginParams.toString();
        const loginPath = loginSearch ? `/login?${loginSearch}` : '/login';
        navigateTo(loginPath);
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;

